export default __webpack_public_path__ + "static/media/psx1.97b4b9a6.jpg";